import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/header/Header";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

const NotFoundView: React.FC = () => {
  useDocumentTitle("404", "Página não encontrada.");
  return (
    <>
      <Header />
      <main
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "70vh",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        <h1 style={{ fontSize: "4rem", margin: 0 }}>404</h1>
        <h2 style={{ fontWeight: 500, marginTop: 8, marginBottom: 16 }}>
          Página não encontrada
        </h2>
        <p style={{ maxWidth: 480, opacity: 0.8 }}>
          O endereço que você acessou não existe ou foi movido.
        </p>
        <Link
          to="/"
          style={{
            marginTop: 24,
            padding: "0.75rem 1.5rem",
            borderRadius: 8,
            background: "#1E90FF",
            color: "#fff",
            textDecoration: "none",
          }}
        >
          Voltar para a página inicial
        </Link>
      </main>
    </>
  );
};

export default NotFoundView;
